export const TranslationUtility = (translations) => {

    function translate(key, replacements = {}, count = null) {
        let translation = getTranslation(key, count) || key;

        Object.keys(replacements).forEach((placeholder) => {
            translation = translation.replace(`:${placeholder}`, replacements[placeholder]);
        });

        return translation;
    }

    function getTranslation(key, count) {
        const keys = key.split('.');
        let translation = translations;

        for (let i = 0; i < keys.length; i++) {
            if (translation[keys[i]] === undefined) {
                return null;
            }
            translation = translation[keys[i]];
        }

        if (count !== null && typeof translation === 'string') {
            return choosePluralForm(translation, count);
        }

        return translation;
    }

    function choosePluralForm(translation, count) {
        const parts = translation.split('|');
        for (let part of parts) {
            const match = part.match(/\[(\d+),\*(\d+)?\]/) || part.match(/(\d+)/);
            if (match) {
                const range = match[1].split(',');
                const min = range[0] ? parseInt(range[0]) : 0;
                const max = range[1] ? parseInt(range[1]) : Infinity;
                if (count >= min && count <= max) {
                    return part.replace(`[${min},*]`, '').trim();
                }
            }
        }
        return parts[count > 1 ? parts.length - 1 : 0];
    }

    return {
        __: translate,
        trans: translate,
    };
};